import { FC } from 'react'
import StatusCritical from '@/assets/images/status-critical.svg?react'
import StatusWarning from '@/assets/images/status-warning.svg?react'
import StatusModerate from '@/assets/images/status-moderate.svg?react'
import StatusLow from '@/assets/images/status-low.svg?react'
import StatusInformational from '@/assets/images/status-informational.svg?react'
import StatusClean from '@/assets/images/status-clean.svg?react'
import { IconTypesProps } from './iconTypes'

type SeverityIconProps = IconTypesProps & {
    severity:
        | 'critical'
        | 'important'
        | 'high'
        | 'moderate'
        | 'medium'
        | 'low'
        | 'informational'
        | 'clean'
}

export const SeverityIcon: FC<SeverityIconProps> = ({
    severity,
    primaryColor = '#010101',
    secondaryColor,
    reverse = false,
    dataTestId,
    width = '14',
    height = '14',
}) => {
    const props = {
        primaryColor,
        secondaryColor,
        reverse,
        width,
        height,
    }

    switch (severity) {
        case 'critical':
            return <StatusCritical data-testid={dataTestId} {...props} />
        case 'important':
        case 'high':
            return <StatusWarning data-testid={dataTestId} {...props} />
        case 'moderate':
        case 'medium':
            return <StatusModerate data-testid={dataTestId} {...props} />
        case 'low':
            return <StatusLow data-testid={dataTestId} {...props} />
        case 'informational':
            return <StatusInformational data-testid={dataTestId} {...props} />
        case 'clean':
            return <StatusClean data-testid={dataTestId} {...props} />
        default:
            return null
    }
}

export default SeverityIcon
